import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedStationStatus: {},
    stationStatuses: [],
  }),

  mutations: {
    setSelectedStationStatus(state, stationStatus) {
      Vue.set(state, "selectedStationStatus", stationStatus);
    },
    setStationStatuses(state, stationStatuses) {
      Vue.set(state, "stationStatuses", stationStatuses);
    },
    setDefaultStationStatusModule(state) {
      Vue.set(state, "selectedStationStatus", {});
      Vue.set(state, "stationStatuses", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createStationStatus: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/station-status/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPublishedStationStatuses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/entity/published").then((response) => {
        return response.data;
      });
    },

    loadStationStatus: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadStationStatuses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/entity").then((response) => {
        context.commit("setStationStatuses", response.data);
        return response.data;
      });
    },

    loadSelectedStationStatusHistory: (context, stationStatus) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/history/" + stationStatus.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteStationStatus: (context, stationStatus) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/station-status/entity/" + stationStatus.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          stationStatus.intents = intents;
          stationStatus.intentId = response.data.id;
          return stationStatus;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftStationStatus: (context, stationStatus) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/station-status/draft/" + stationStatus.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishStationStatus: (context, stationStatus) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/publish/" + stationStatus.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectStationStatus: (context, stationStatus) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/reject/" + stationStatus.intentId).then((response) => {
        helper.recallOrRejectEntity(stationStatus, "station_status");
        return response.data;
      });
    },
    sendToApprovalStationStatuses: (context, stationStatus) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/sendToApproval/" + stationStatus.intentId).then((response) => {
        if (stationStatus.intents[0].type === "CREATE_STATION_STATUS") {
          stationStatus.intents[0].status = "WAITING_APPROVAL";
        } else if (stationStatus.intents[0].type === "UPDATE_STATION_STATUS") {
          stationStatus.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallStationStatus: (context, stationStatus) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/recall/" + stationStatus.intentId).then((response) => {
        helper.recallOrRejectEntity(stationStatus, "station_status");
        return response.data;
      });
    },

    cancelStationStatus: (context, stationStatus) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/cancel/" + stationStatus.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedStationStatus: (state) => {
      return state.selectedStationStatus;
    },
    getStationStatuses: (state) => {
      return state.stationStatuses;
    },
    getPublishedStationStatuses: (state) => {
      return state.stationStatuses.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
